(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mad-duck-route-grid"] && !Shopify.designMode) return;
  try {
    (function(){
function build(){
const marker=document.getElementById('md-route-library');
if(!marker || marker.dataset.ready)return;
const content=document.getElementById('md-route-source');
if(!content)return;
const entries=[],seen=new Set();
function add(raw,label){
try{
const url=new URL(raw);
if(!['ridewithgps.com','www.ridewithgps.com'].includes(url.hostname)||!['https:','http:'].includes(url.protocol))return;
const match=url.pathname.match(/^\/routes\/([0-9]+)\/?$/);
if(!match||seen.has(match[1]))return;
seen.add(match[1]);
entries.push({id:match[1],title:label&&!/https?:\/\/|ridewithgps\.com/i.test(label)?label.trim():''});
}catch(e){}
}
function scan(node){
if(node.nodeType===1){
if(['SCRIPT','STYLE','IFRAME'].includes(node.tagName)||node.id==='md-route-library')return;
if(node.tagName==='A'){add(node.getAttribute('href'),node.textContent);return;}
for(const child of node.childNodes)scan(child);
}else if(node.nodeType===3){
for(const found of node.textContent.matchAll(/https?:\/\/(?:www\.)?ridewithgps\.com\/routes\/[0-9]+(?:[/?#][^\s<>"']*)?/gi))add(found[0],'');
}
}
for(const child of content.childNodes)scan(child);
if(!entries.length)return;
const grid=document.createElement('div');grid.className='md-route-grid';
entries.forEach((entry,index)=>{
const card=document.createElement('article');card.className='md-route-card';
if(entry.title){const h=document.createElement('h2');h.textContent=entry.title;card.appendChild(h);}
const frame=document.createElement('iframe');
frame.src='https://ridewithgps.com/embeds?type=route&id='+entry.id+'&sampleGraph=true';
frame.title=(entry.title||marker.dataset.routeLabel+' '+(index+1))+' — '+marker.dataset.mapLabel;
frame.loading='lazy';frame.setAttribute('scrolling','no');card.appendChild(frame);
const footer=document.createElement('div');footer.className='md-route-footer';
const button=document.createElement('a');button.className='md-route-button';
button.href='https://ridewithgps.com/routes/'+entry.id;button.target='_blank';button.rel='noopener noreferrer';
button.textContent=marker.dataset.openLabel;footer.appendChild(button);card.appendChild(footer);grid.appendChild(card);
});
marker.dataset.ready='true';marker.appendChild(grid);content.hidden=true;
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build,{once:true});else build();
})();
  } catch(e) { console.error(e); }
})();

})();
